import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDynamicConfigurations } from './dynamic_config_service';
import { setDynamicConfigurations } from './dynamicConfigSlice';

export default function useDynamicConfig() {
  const dispatch = useDispatch();
  const config = useSelector((state) => state.dynamicConfig);
  const [loading, setLoading] = useState(!config.prodApiServerBaseUrl);

  useEffect(() => {
    if (!config.prodApiServerBaseUrl) {
      fetchDynamicConfigurations()
        .then((data) => dispatch(setDynamicConfigurations(data)))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [dispatch, config.prodApiServerBaseUrl]);

  return { config, loading };
}
